export const TYPE_REQUEST_FORMATTERS = 'formatters/REQUEST_FORMATTERS';
export const TYPE_RECEIVE_FORMATTERS_SUCCESS = 'formatters/TYPE_RECEIVE_FORMATTERS_SUCCESS';
export const TYPE_RECEIVE_FORMATTERS_CACHED = 'formatters/RECEIVE_FORMATTERS_CACHED';
export const TYPE_RECEIVE_FORMATTERS_ERROR = 'formatters/RECEIVE_FORMATTERS_ERROR';
